<template>
  <div>
    <div>
      <p style="font-size: 16px; margin: -8px 0 16px;">
        正在查看【{{ nickName }}】的视频 - <el-tag class="ml-2" :type="type" effect="dark">{{ state }}</el-tag>
      </p>
      <div style="text-align:center;background-color: #000;">
        <video autoplay preload="auto" controls="controls" oncontextmenu="return false;" style="display:block; width: 100%; height: 420px;">
          <source v-for="(item, index) in infoList" :key="index" :src="item.playURL" :type="'video/'+item.format">
        </video>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button type="primary"  @click="pass" v-loading="passLoading">通 过</el-button>
      <el-button type="danger"  @click="reject" >不通过</el-button>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api";
import {getAuthVideoInfo, bathUpdateAuthVideo} from "@/api/url"
import Dialog from "@/assets/js/dialog";
import VideoRejectDialog from "@/views/auth/components/VideoRejectDialog";

export default {
  name: "VideoPlay",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.videoForm.id,
      videoId: this.value.videoForm.videoId,
      nickName: this.value.videoForm.nickName,
      state: this.value.videoForm.state == 1?'待审核':this.value.videoForm.state == 2?'已通过':this.value.videoForm.state == 3?'不通过':'',
      type: this.value.videoForm.state == 1?'primary':this.value.videoForm.state == 2?'success':this.value.videoForm.state == 3?'danger':'',
      infoList: [],
      passLoading: false,
    }
  },
  methods: {
    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },
    getVideo() {
      getFormData(getAuthVideoInfo, {videoId: this.videoId}).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          this.infoList = data.data;
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(() => {

      })
    },

    //审核
    pass() {
      this.$confirm('确认通过该视频认证？').then(() => {
        this.passLoading = true;
        let _this = this;
        let param = {};
        let ids = [];
        ids.push(this.id)
        param['idArr'] = ids;
        param['state'] = 2;
        param['warnMsg'] = '';
        postFormData(bathUpdateAuthVideo,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.passLoading = false;
        })
            .catch(function(response){
              _this.passLoading = false;
            })
      })
          .catch(() => {})
    },

    reject() {
      let ids = [];
      ids.push(this.id)
      Dialog.open({
        title: '编辑发送视频不通过原因',
        component: VideoRejectDialog,
        data: {
          ids: ids,
          width: '500px'
        },
        confirm: () => {
          this.$emit('confirm');
        }
      })
    }

  },
  mounted() {
    this.getVideo()
  }
}
</script>

<style scoped>

</style>
